module.exports = "data:image/jpeg;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvaW1nL2xvZ29lbnRldGUuanBnIjs="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logoentete.jpg
// module id = MQDq
// module chunks = 1